module.exports = __webpack_public_path__ + "static/img/img-tach.1d953cb7.png";